"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BreedLimitDialog = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const mui_inputs_core_1 = require("@dzambalaorg/mui-inputs-core");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const BreedLimitDialog = () => {
    return ((0, jsx_runtime_1.jsxs)(ui_kit_1.FormGrid, { columns: [3], children: [(0, jsx_runtime_1.jsx)(mui_inputs_core_1.TextInput, { name: "count" }), (0, jsx_runtime_1.jsx)(mui_inputs_core_1.TextInput, { name: "time" }), (0, jsx_runtime_1.jsx)(mui_inputs_core_1.TextInput, { name: "maxTime" })] }));
};
exports.BreedLimitDialog = BreedLimitDialog;
//# sourceMappingURL=index.js.map